import React from 'react';
import AzureCloudLogo from './images/azurecloudlogo.png';
import { useLocation } from 'react-router-dom';

function AzureCloudRibbon() {
  const location = useLocation();
  const [onHover, setOnHover] = React.useState(false);
  const handleMouseEnter = () => setOnHover(true);
  const handleMouseLeave = () => setOnHover(false);

  return (
    <div className="azure-ribbon-container" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <div className="azure-ribbon">
        <a href="#">
          {onHover ? (
            <>
              <h4>
                <img width={30} src={AzureCloudLogo} alt="azure cloud logo" />
                {'   '}Microsoft Azure
              </h4>
              <p>Cloud Instance</p>
            </>
          ) : (
            <>
              <label className="mini-logo-right" style={{ paddingLeft: '2px' }}>
                ✔
              </label>
            </>
          )}
        </a>
      </div>
    </div>
  );
}

export default AzureCloudRibbon;
